var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4584 22.2084L23.7397 11.9271L21.698 9.88544L13.4584 18.125L9.30216 13.9688L7.2605 16.0104L13.4584 22.2084ZM15.5001 30.0834C13.4827 30.0834 11.5869 29.7005 9.81258 28.9349C8.03828 28.1693 6.49487 27.1302 5.18237 25.8177C3.86987 24.5052 2.83081 22.9618 2.06519 21.1875C1.29956 19.4132 0.916748 17.5174 0.916748 15.5C0.916748 13.4827 1.29956 11.5868 2.06519 9.81252C2.83081 8.03821 3.86987 6.49481 5.18237 5.18231C6.49487 3.86981 8.03828 2.83075 9.81258 2.06512C11.5869 1.2995 13.4827 0.916687 15.5001 0.916687C17.5174 0.916687 19.4133 1.2995 21.1876 2.06512C22.9619 2.83075 24.5053 3.86981 25.8178 5.18231C27.1303 6.49481 28.1694 8.03821 28.935 9.81252C29.7006 11.5868 30.0834 13.4827 30.0834 15.5C30.0834 17.5174 29.7006 19.4132 28.935 21.1875C28.1694 22.9618 27.1303 24.5052 25.8178 25.8177C24.5053 27.1302 22.9619 28.1693 21.1876 28.9349C19.4133 29.7005 17.5174 30.0834 15.5001 30.0834ZM15.5001 27.1667C18.757 27.1667 21.5157 26.0365 23.7761 23.7761C26.0365 21.5156 27.1667 18.757 27.1667 15.5C27.1667 12.2431 26.0365 9.4844 23.7761 7.22398C21.5157 4.96356 18.757 3.83335 15.5001 3.83335C12.2431 3.83335 9.48446 4.96356 7.22404 7.22398C4.96362 9.4844 3.83341 12.2431 3.83341 15.5C3.83341 18.757 4.96362 21.5156 7.22404 23.7761C9.48446 26.0365 12.2431 27.1667 15.5001 27.1667Z",
    fill: "url(#paint0_linear_102_28151)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_28151",
    x1: 0.916748,
    y1: 15.5,
    x2: 30.0834,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5CA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B316A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRefund);
export default __webpack_public_path__ + "static/media/check-refund.78e3d5df26f05b9b34ae4f518969096f.svg";
export { ForwardRef as ReactComponent };